import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { TopicHomepage } from '@confluence/topics/entry-points/TopicHomepage.tsx';
import { PRODUCT_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { HOME } from '@confluence/named-routes/entry-points/routes.ts';
import { Redirection } from '@confluence/route-manager/entry-points/Redirection.ts';
import { fg } from '@confluence/feature-gating';

export const TopicsRoute: {
	({ params: { topicId } }: RouteMatch): React.JSX.Element;
	NAVIGATION_PARAMS({ params: { topicId } }: RouteMatch): {
		Screen: {
			screenEvent: {
				name: string;
			};
			pageState: {
				topicId: string;
			};
		};
		MainLayout: {
			navView: string;
			topicId: string;
		};
	};
} = ({ params: { topicId } }: RouteMatch): React.JSX.Element => {
	if (!fg('confluence_enable_ai_topics_homepage')) {
		return <Redirection name={HOME.name} />;
	}
	return <TopicHomepage topicId={topicId} />;
};

TopicsRoute.NAVIGATION_PARAMS = ({
	params: { topicId },
}: RouteMatch): {
	Screen: {
		screenEvent: {
			name: string;
		};
		pageState: {
			topicId: string;
		};
	};
	MainLayout: {
		navView: string;
		topicId: string;
	};
} => ({
	Screen: {
		screenEvent: { name: 'topicsScreen' },
		pageState: {
			topicId,
		},
	},
	MainLayout: {
		navView: PRODUCT_HOME_ID,
		topicId,
	},
});
